var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99998 21.3333C9.92045 21.3333 10.6666 20.5871 10.6666 19.6667C10.6666 18.7462 9.92045 18 8.99998 18C8.07951 18 7.33331 18.7462 7.33331 19.6667C7.33331 20.5871 8.07951 21.3333 8.99998 21.3333Z",
    fill: "#FF8F01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 21.3333C23.9204 21.3333 24.6666 20.5871 24.6666 19.6667C24.6666 18.7462 23.9204 18 23 18C22.0795 18 21.3333 18.7462 21.3333 19.6667C21.3333 20.5871 22.0795 21.3333 23 21.3333Z",
    fill: "#FF8F01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 24.6667C3.56212 24.6667 2.66669 23.7713 2.66669 22.6667V16.4731C2.66669 14.9575 3.52326 13.5721 4.87909 12.8948L5.33371 12.6677L6.87369 6.06129C7.15509 4.85411 8.23116 4 9.47069 4H22.5962C23.845 4 24.9266 4.86665 25.1988 6.08544L26.6688 12.6677L27.1223 12.8944C28.4774 13.572 29.3334 14.957 29.3334 16.4721V22.6667C29.3334 23.7713 28.438 24.6667 27.3334 24.6667H26.0021V25.3333C26.0021 26.8061 24.8072 28 23.3344 28C21.8616 28 20.6667 26.8061 20.6667 25.3333V24.6667H11.3334V25.3335C11.3334 26.8062 10.1396 28 8.66689 28C7.19422 28 6.00037 26.8062 6.00037 25.3335V24.6667H4.66669Z",
    stroke: "#FF8F01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 14.6667H22.6666L21.5653 9.71082C21.4298 9.10081 20.8887 8.66675 20.2638 8.66675H11.7362C11.1112 8.66675 10.5702 9.10081 10.4346 9.71082L9.33331 14.6667Z",
    stroke: "#FF8F01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.f16d5ac6d7920019f730983a5f7c0e80.svg";
export { ForwardRef as ReactComponent };